import { FormField } from "@rothoblaas/design-system";
import type { ComponentProps, FC } from "react";
import useI18n from "../../../../../hooks/useTranslations";
import { fieldNoticeText } from "./noticeText";
import { useNoticeTarget, useNotices } from "./NoticesContext";

type NoticeFormFieldProps = ComponentProps<typeof FormField> & {
  /** Form path of the field: the notices that name it show as its warning, and "go to field" lands on it. */
  name?: string;
};

/** The design-system FormField, wired to the notices registry. Without `name` it is the plain FormField. */
export const NoticeFormField: FC<NoticeFormFieldProps> = ({ name, warning, ...props }) => {
  const { noticesForField } = useNotices();
  const targetRef = useNoticeTarget(name);
  const { translation: t } = useI18n();
  if (!name) return <FormField warning={warning} {...props} />;
  return (
    // display: contents keeps the field's layout; the ref is how "go to field" finds it.
    <div ref={targetRef} style={{ display: "contents" }}>
      <FormField warning={warning ?? fieldNoticeText(noticesForField(name), t)} {...props} />
    </div>
  );
};
